import React, { useState } from 'react';
import { fetchCancelPolicies, calcCancelFee } from "utils/cancelPolicy";
import CancelPolicyTable from "../../../components/Common/CancelPolicyTable";
import { Card, CardBody, Col, Row, Nav, NavItem, NavLink, TabContent, TabPane, Table, Badge, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Spinner } from 'reactstrap';
import classnames from 'classnames';

const parseDuration = (dur) => {
    if (!dur) return "-";
    const match = dur.match(/PT(\d+)H(\d+)M/);
    if (!match) return dur;
    return `${String(match[1]).padStart(2,'0')}:${String(match[2]).padStart(2,'0')}`;
};

const DetailsSection = ({ detail }) => {
    // Sekmeler için state
    const [activeTab, setActiveTab] = useState('1');

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
    const isAdmin = authUser?.Users_Type_ID === 3;
    const isCustomer = authUser?.Users_Type_ID === 1;
    const userId = authUser?.ID;

    // Düzenleme modalı state'leri
    const [editModal, setEditModal] = useState(false);
    const [editOffer, setEditOffer] = useState(null);
    const [editPrice, setEditPrice] = useState("");
    const [editLoading, setEditLoading] = useState(false);

    // MASRAF DETAYI MODALI STATE'LERİ
    const [expenseModal, setExpenseModal] = useState(false);
    const [viewExpense, setViewExpense] = useState(null);

    // İPTAL ONAY MODALI STATE'LERİ (kademeli iptal koşullarını gösterir)
    const [cancelModal, setCancelModal] = useState(false);
    const [cancelLoading, setCancelLoading] = useState(false);
    const [cancelData, setCancelData] = useState({ offerId: null, diffDays: 0, fee: 0, pricingId: null, policies: [] });

    const openEditModal = (offer) => {
        setEditOffer(offer);
        setEditPrice(String(offer.Own_Offer || offer.Price || ""));
        setEditModal(true);
    };

    // İlgili teklifin masrafını bulup modalı açan fonksiyon
    const openExpenseModal = (offer) => {
        // detail.expenses içinde bu teklife ait masrafı arıyoruz
        const exp = detail.expenses.find(e => e.Advert_Offers_ID === offer.ID || e.Users_ID === offer.Users_ID);
        setViewExpense(exp || null);
        setExpenseModal(true);
    };

    const handleEditSubmit = async () => {
        if (!editOffer || !editPrice) return;
        setEditLoading(true);
        try {
            const newPrice = Number(editPrice);
            const res = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert_Offers(${editOffer.ID})`, {
                method: "PATCH",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Own_Offer: newPrice,
                    Price: newPrice,
                    IsUpdated: true
                })
            });
            if (res.ok) {
                alert("Teklifiniz başarıyla güncellendi.");
                setEditModal(false);
                window.location.reload();
            } else {
                alert("Güncelleme sırasında bir hata oluştu.");
            }
        } catch (e) {
            alert("Bağlantı hatası.");
        } finally {
            setEditLoading(false);
        }
    };

    const updateOfferStatus = async (offerId, newStatus) => {
        let rejectionReason = null;

        if (newStatus === 'Reddedildi') {
            rejectionReason = window.prompt("Lütfen red nedenini giriniz (Opsiyonel):");
            if (rejectionReason === null) return; 
        } else {
            if (!window.confirm(`Bu teklifi "${newStatus}" olarak işaretlemek istediğinize emin misiniz?`)) {
                return;
            }
        }

        try {
            const payload = {
                Offer_Status: newStatus,
                ReasonForRejection: newStatus === 'Reddedildi' ? rejectionReason : null 
            };

            const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert_Offers(${offerId})`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                alert(`Teklif başarıyla ${newStatus} olarak güncellendi!`);
                window.location.reload(); 
            } else {
                alert("Teklif güncellenirken bir hata oluştu.");
            }
        } catch (error) {
            console.error("Güncelleme hatası:", error);
            alert("Bağlantı hatası oluştu.");
        }
    };

    const handleCancelTask = async (offerId) => {
        if (!detail?.advertStartISO) {
            alert("İlan başlangıç tarihi bulunamadı.");
            return;
        }

        const startDate = new Date(detail.advertStartISO);
        const now = new Date();
        const startDay = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const diffDays = Math.round((startDay.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

        if (diffDays < 0) {
            alert("⚠️ Geçmiş tarihli görev iptal edilemez.");
            return;
        }

        let policies = [];
        try {
            policies = await fetchCancelPolicies();
        } catch {
            alert("İptal politikası yüklenemedi. Lütfen tekrar deneyin.");
            return;
        }

        const isPickedUp = (detail?.deliveryStatus || []).some(
            s => s?.Advert_DeliveryStatus_Status === "TESLIM_ALMA"
        );

        // Admin override: TESLIM_ALMA sonrası iptali admin yapabilir (ek onayla).
        const { fee, pricingId, canCancel, message } = calcCancelFee(
            diffDays,
            policies,
            isAdmin ? false : isPickedUp
        );
        if (!canCancel) {
            alert(message || "Bu görev iptal edilemez.");
            return;
        }
        if (isAdmin && isPickedUp) {
            const ok = window.confirm(
                "DİKKAT: Sürücü bu görevi TESLİM ALMIŞ durumda. Yine de admin yetkisiyle iptal etmek istiyor musunuz?"
            );
            if (!ok) return;
        }

        // İptal koşullarını (kademe tablosunu) onay modalında kullanıcıya göster.
        setCancelData({ offerId, diffDays, fee, pricingId, policies });
        setCancelModal(true);
    };

    // İptal modalında onaylandıktan sonra çalışır.
    const performCancel = async () => {
        const { offerId, fee, pricingId } = cancelData;
        setCancelLoading(true);
        try {
            const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert_Offers(${offerId})`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ Offer_Status: "İptal Edildi" })
            });

            if (!response.ok) {
                alert("İptal işlemi sırasında sunucu tarafında bir hata oluştu.");
                setCancelLoading(false);
                return;
            }

            if (fee > 0 && pricingId) {
                await fetch(`https://hiflowapi.stechomeyazilim.info/Users_Advert_Pricing`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        Advert_ID: detail.id,
                        Users_ID: userId,
                        Advert_Pricing_ID: pricingId,
                        Price: fee
                    })
                });
            }

            alert(`Görev başarıyla iptal edildi. Kesilen ücret: ${fee} TL`);
            window.location.reload();
        } catch (error) {
            console.error("Görevi İptal Etme Hatası:", error);
            alert("İnternet bağlantınızı kontrol edin veya daha sonra tekrar deneyin.");
        } finally {
            setCancelLoading(false);
        }
    };

    return (
        <React.Fragment>
            <Col xl={8}>
                {/* 1. ROTA KARTI */}
                <Card className="border shadow-none mb-4 rounded-3">
                    <CardBody>
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-4">
                            <div className="bg-dark text-white px-3 py-1 rounded-pill fw-medium">
                                Rota {detail.distance} - {detail.duration}
                            </div>
                            {/* Google Maps Rota Butonu */}
                            <a
                                href={`https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(detail.start.address || detail.start.city)}&destination=${encodeURIComponent(detail.end.address || detail.end.city)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: 'inline-flex', alignItems: 'center', gap: 6,
                                    background: 'linear-gradient(135deg, #4285f4, #34a853)',
                                    color: '#fff', borderRadius: 8, padding: '7px 16px',
                                    fontWeight: 600, fontSize: 13, textDecoration: 'none',
                                    boxShadow: '0 4px 12px rgba(66,133,244,0.35)'
                                }}
                            >
                                <i className="mdi mdi-google-maps fs-5"></i>
                                Google Maps'te Rotayı Gör
                            </a>
                        </div>

                        <Row>
                            <Col md={6} className="border-end border-light">
                                <div className="d-flex mb-3">
                                    <div className="me-2">
                                        <div style={{
                                            width: 14, height: 14, borderRadius: '50%',
                                            background: '#28a745', marginTop: 6
                                        }} />
                                    </div>
                                    <div>
                                        <h5 className="mb-1 fw-bold text-success">{detail.start.city}</h5>
                                        <p className="text-muted mb-3" style={{ fontSize: 12 }}>{detail.start.date}</p>

                                        <h6 className="text-muted text-uppercase fs-12 mb-1">Kalkış Adresi</h6>
                                        <p className="mb-2 text-dark" style={{ whiteSpace: "pre-wrap" }}>
                                            {detail.start.address}
                                        </p>
                                        <a
                                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(detail.start.address || detail.start.city)}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ fontSize: 11, color: '#4285f4', textDecoration: 'none', fontWeight: 600 }}
                                        >
                                            <i className="mdi mdi-map-marker me-1"></i>Haritada Göster
                                        </a>
                                    </div>
                                </div>
                            </Col>
                            <Col md={6} className="ps-md-4">
                                <div className="d-flex mb-3">
                                    <div className="me-2">
                                        <div style={{
                                            width: 14, height: 14, borderRadius: 3,
                                            background: '#dc3545', marginTop: 6
                                        }} />
                                    </div>
                                    <div>
                                        <h5 className="mb-1 fw-bold text-danger">{detail.end.city}</h5>
                                        <p className="text-muted mb-3" style={{ fontSize: 12 }}>{detail.end.date}</p>

                                        <h6 className="text-muted text-uppercase fs-12 mb-1">Varış Adresi</h6>
                                        <p className="mb-2 text-dark" style={{ whiteSpace: "pre-wrap" }}>
                                            {detail.end.address}
                                        </p>
                                        <a
                                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(detail.end.address || detail.end.city)}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ fontSize: 11, color: '#4285f4', textDecoration: 'none', fontWeight: 600 }}
                                        >
                                            <i className="mdi mdi-map-marker me-1"></i>Haritada Göster
                                        </a>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* 2. ARAÇ KARTI */}
                <Card className="border shadow-none mb-4 rounded-3">
                    <CardBody>
                        <div className="bg-dark text-white px-3 py-1 rounded-pill d-inline-block mb-4 fw-medium">
                            Araç Bilgileri
                        </div>
                        
                        <Row>
                            <Col md={7} className="border-end border-light">
                                <h6 className="d-flex align-items-center mb-4 text-dark fw-bold">
                                    <i className="mdi mdi-car me-2 fs-4 text-primary"></i> Araç Detayı
                                </h6>
                                <Row className="gy-3">
                                    <Col xs={4}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">MARKA</p>
                                        <h6 className="fw-bold">{detail.vehicle.brand}</h6>
                                    </Col>
                                    <Col xs={4}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">MODEL</p>
                                        <h6 className="fw-bold">{detail.vehicle.model}</h6>
                                    </Col>
                                    <Col xs={4}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">KASA TİPİ</p>
                                        <h6 className="fw-bold">{detail.vehicle.bodyType}</h6>
                                    </Col>
                                    <Col xs={4}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">PLAKA</p>
                                        <h6 className="fw-bold text-primary">{detail.vehicle.plate}</h6>
                                    </Col>
                                    <Col xs={8}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">ŞASE NO</p>
                                        <h6 className="fw-bold">{detail.vehicle.chassis}</h6>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={5} className="ps-md-4">
                                <h6 className="d-flex align-items-center mb-4 text-dark fw-bold">
                                    <i className="mdi mdi-gas-station me-2 fs-4 text-primary"></i> Operasyon & Yakıt
                                </h6>
                                <Row>
                                    <Col xs={12} className="mb-3">
                                        <p className="text-muted text-uppercase fs-12 mb-1">YAKIT TÜRÜ & DURUMU</p>
                                        <h6 className="fw-bold">{detail.vehicle.engine} - <span className="text-info">{detail.fuelStatus}</span></h6>
                                    </Col>
                                    <Col xs={12}>
                                        <p className="text-muted text-uppercase fs-12 mb-1">MÜŞTERİ NOTLARI</p>
                                        <p className="mb-0 fs-13 text-danger fw-medium">{detail.customerNotes}</p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* 3. İLİŞKİLİ VERİLER (SEKMELER) */}
                <Card className="border shadow-none mb-4 rounded-3">
                    <CardBody className="pb-0">
                   {/* 3. İLİŞKİLİ VERİLER (SEKMELER) */}
<Nav tabs className="nav-tabs-custom">
    <NavItem>
        <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === '1' })} onClick={() => toggle('1')}>
            Görev Tanımı
        </NavLink>
    </NavItem>
    
    {/* SADECE ADMIN TEKLİFLERİ GÖREBİLİR */}
    {isAdmin && (
        <NavItem>
            <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === '2' })} onClick={() => toggle('2')}>
                Teklifler <Badge color="danger" pill className="ms-1">{detail.offers.length}</Badge>
            </NavLink>
        </NavItem>
    )}

    <NavItem>
        <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === '3' })} onClick={() => toggle('3')}>
            Tüm Masraflar
        </NavLink>
    </NavItem>
</Nav>
                    </CardBody>

                    <CardBody>
                        <TabContent activeTab={activeTab}>
                            
                            {/* SEKME 1: GÖREV TANIMI */}
                            <TabPane tabId="1">
                                <Row className="gy-4">
                                    <Col md={6}>
                                        <h6 className="d-flex align-items-center mb-3 fw-bold">
                                            <i className="mdi mdi-cog-outline me-2 text-primary fs-5"></i> Tamamlayıcı hizmetler
                                        </h6>
                                        <ul className="list-unstyled mb-0">
                                            {detail.services.map((service, index) => (
                                                <li key={index} className="mb-2 d-flex align-items-start">
                                                    <i className="mdi mdi-check text-success me-2 mt-1"></i> {service}
                                                </li>
                                            ))}
                                        </ul>
                                    </Col>
                                    <Col md={6}>
                                        <h6 className="d-flex align-items-center mb-3 fw-bold">
                                            <i className="mdi mdi-clipboard-text-outline me-2 text-primary fs-5"></i> Taşıma prosedürü
                                        </h6>
                                        <p className="mb-0"><strong>Yön:</strong> {detail.direction}</p>
                                    </Col>
                                </Row>
                            </TabPane>

                            {/* SEKME 2: TEKLİFLER */}
                            {isAdmin && (
                            <TabPane tabId="2">
                                {(() => {
                                    const visibleOffers = isAdmin ? detail.offers : [];
                                    return visibleOffers.length > 0 ? (
                                    <div className="table-responsive">
                                        <Table className="table-sm table-nowrap mb-0 align-middle">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Teklif No</th>
                                                    {!isCustomer && <th>Sürücü</th>}
                                                    <th>Fiyat / Net / Yol</th>
                                                    <th>Tarih / Saat</th>
                                                    <th>Durum</th>
                                                    <th className="text-end">Eylemler</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {visibleOffers.map((offer, i) => {
                                                    let badgeColor = "warning";
                                                    if (offer.Offer_Status?.includes('Kabul')) badgeColor = "success";
                                                    if (offer.Offer_Status?.includes('Red')) badgeColor = "danger";

                                                    const isMyOffer = offer.Users_ID === userId;
                                                    const hasTravelExpense = Number(offer.Travel_Expenses || 0) > 0;

                                                    return (
                                                        <tr key={i} className={isMyOffer ? "table-info" : ""}>
                                                            <td>
                                                                <div>#{offer.ID}</div>
                                                                {isMyOffer && (
                                                                    <Badge color="info" className="me-1 mt-1">
                                                                        <i className="mdi mdi-star me-1"></i>Senin Teklifin
                                                                    </Badge>
                                                                )}
                                                                {offer.Quickly && (
                                                                    <Badge color="warning" className="mt-1">
                                                                        <i className="mdi mdi-flash me-1"></i>Hızlı
                                                                    </Badge>
                                                                )}
                                                            </td>
                                                            {!isCustomer && (
                                                                <td>
                                                                    <span className="fw-medium text-dark d-block">
                                                                        {offer.Users ? offer.Users.Users_NameSurname : "Bilinmiyor"}
                                                                    </span>
                                                                    <span className="text-muted" style={{fontSize: "11px"}}>
                                                                        ID: #{offer.Users_ID}
                                                                    </span>
                                                                </td>
                                                            )}
                                                            <td>
                                                                <div className="fw-bold text-primary">{Number(offer.Price || 0).toFixed(2)} ₺</div>
                                                                <div className="text-muted" style={{fontSize:"11px"}}>Net: {Number(offer.Own_Offer || 0).toFixed(2)} ₺</div>
                                                                
                                                                {/* YOL VE DETAY BUTONU BURADA */}
                                                                <div className="text-muted d-flex align-items-center" style={{fontSize:"11px"}}>
                                                                    Yol: {Number(offer.Travel_Expenses || 0).toFixed(2)} ₺
                                                                    {hasTravelExpense && (
                                                                        <Badge 
                                                                            color="info" 
                                                                            pill 
                                                                            className="ms-2" 
                                                                            style={{cursor: "pointer"}} 
                                                                            onClick={() => openExpenseModal(offer)}
                                                                        >
                                                                            <i className="mdi mdi-eye me-1"></i>Detay
                                                                        </Badge>
                                                                    )}
                                                                </div>

                                                            </td>
                                                            <td style={{fontSize:"11px", whiteSpace:"nowrap"}}>
                                                                {offer.Delivery_Date && <div><strong>Bşl:</strong> {new Date(offer.Delivery_Date).toLocaleDateString('tr-TR')}</div>}
                                                                {(offer.Start_Time || offer.End_Time) && (
                                                                    <div>{parseDuration(offer.Start_Time)} - {parseDuration(offer.End_Time)}</div>
                                                                )}
                                                                {offer.DateTime_ && <div><strong>Bit:</strong> {new Date(offer.DateTime_).toLocaleDateString('tr-TR')}</div>}
                                                                {!offer.Delivery_Date && !offer.Start_Time && !offer.DateTime_ && (
                                                                    <span className="text-muted">{new Date(offer.Created_DateTime).toLocaleString('tr-TR')}</span>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <Badge color={badgeColor}>{offer.Offer_Status || "Bekliyor"}</Badge>
                                                                {offer.IsUpdated && (
                                                                    <Badge color="info" className="ms-1">Güncellendi</Badge>
                                                                )}
                                                                {offer.Offer_Status === "Reddedildi" && offer.ReasonForRejection && (
                                                                    <div className="text-danger mt-1" style={{fontSize: "11px", whiteSpace: "normal", maxWidth: "150px"}}>
                                                                        <strong>Neden:</strong> {offer.ReasonForRejection}
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td className="text-end">
                                                                {isAdmin && !offer.Quickly && (
                                                                    <div className="d-flex justify-content-end gap-2 mb-1">
                                                                        <button
                                                                            className="btn btn-success btn-sm"
                                                                            disabled={offer.Offer_Status === "Kabul Edildi"}
                                                                            onClick={() => updateOfferStatus(offer.ID, 'Kabul Edildi')}
                                                                        >
                                                                            <i className="mdi mdi-check me-1"></i> Kabul Et
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-danger btn-sm"
                                                                            disabled={offer.Offer_Status === "Reddedildi"}
                                                                            onClick={() => updateOfferStatus(offer.ID, 'Reddedildi')}
                                                                        >
                                                                            <i className="mdi mdi-close me-1"></i> Reddet
                                                                        </button>
                                                                    </div>
                                                                )}
                                                                {isAdmin && offer.Quickly && (
                                                                    <Badge color="warning" className="p-2">
                                                                        <i className="mdi mdi-flash me-1"></i>Hızlı Teklif
                                                                    </Badge>
                                                                )}
                                                                {offer.Users_ID === userId && (
                                                                    (offer.Offer_Status === "Kabul Edildi" || offer.Offer_Status === "Onaylandı") ? (
                                                                        offer.Quickly ? (
                                                                            <Badge color="danger" className="p-2 border border-dark">
                                                                                <i className="mdi mdi-lock me-1"></i> Hızlı İptal Edilemez
                                                                            </Badge>
                                                                        ) : (
                                                                            <Button size="sm" color="danger" onClick={() => handleCancelTask(offer.ID)}>
                                                                                <i className="mdi mdi-close-circle me-1"></i> İptal Et
                                                                            </Button>
                                                                        )
                                                                    ) : (
                                                                        offer.Quickly ? (
                                                                            <Badge color="warning" className="p-2 border border-dark">
                                                                                <i className="mdi mdi-lock me-1"></i> Hızlı Düzenlenemez
                                                                            </Badge>
                                                                        ) : (
                                                                            <Button size="sm" color="primary" outline onClick={() => openEditModal(offer)}>
                                                                                <i className="mdi mdi-pencil me-1"></i> Düzenle
                                                                            </Button>
                                                                        )
                                                                    )
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                ) : (
                                    <p className="text-muted fst-italic mb-0">
                                        Henüz bu ilana yapılmış bir teklif bulunmuyor.
                                    </p>
                                );
                                })()}
                            </TabPane>
                            )}

                            {/* SEKME 3: MASRAFLAR */}
                            <TabPane tabId="3">
                                {detail.expenses.length > 0 ? (
                                    detail.expenses.map((exp, i) => (
                                        <div key={i} className="mb-4">
                                            {detail.expenses.length > 1 && (
                                                <h6 className="text-muted mb-2 border-bottom pb-2">
                                                    Sürücü #{exp.Users_ID} — Masraf Kaydı #{i + 1}
                                                </h6>
                                            )}
                                            <div className="border rounded p-3">
                                                {[
                                                    { icon: "mdi-gas-station", label: "YAKIT MASRAFI", value: exp.Fuel_Expense },
                                                    { icon: "mdi-highway", label: "OTOYOL ÜCRETİ", value: exp.Toll_Fee },
                                                    { icon: "mdi-bus", label: "TOPLU TAŞIMA", value: exp.Public_Transport },
                                                    { icon: "mdi-taxi", label: "TAKSİ GİDERİ", value: exp.Taxi_Expense },
                                                    { icon: "mdi-alert-circle-outline", label: "İSTİSNAİ MASRAFLAR", value: exp.Exceptional_Expense },
                                                ].map((item, idx) => (
                                                    <div key={idx} className="d-flex align-items-center justify-content-between py-2 border-bottom">
                                                        <div className="d-flex align-items-center">
                                                            <div className="me-3 rounded p-2" style={{backgroundColor:"#fff3e0"}}>
                                                                <i className={`mdi ${item.icon} text-warning fs-5`}></i>
                                                            </div>
                                                            <span className="fw-medium text-uppercase" style={{fontSize:"12px"}}>{item.label}</span>
                                                        </div>
                                                        <span className="fw-bold">{Number(item.value || 0).toFixed(2)} TL</span>
                                                    </div>
                                                ))}
                                                <div className="d-flex justify-content-between align-items-center pt-3">
                                                    <span className="fw-bold text-uppercase">Toplam Masraf</span>
                                                    <span className="fw-bold text-danger fs-6">{Number(exp.Total_Expense || 0).toFixed(2)} TL</span>
                                                </div>
                                                {exp.Is_Approved !== undefined && (
                                                    <div className="mt-2">
                                                        <Badge color={exp.Is_Approved ? "success" : "warning"}>
                                                            {exp.Is_Approved ? "Onaylandı" : "Onay Bekliyor"}
                                                        </Badge>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p className="text-muted fst-italic mb-0">Bu görev için henüz masraf kaydı girilmemiş.</p>
                                )}
                            </TabPane>

                        </TabContent>
                    </CardBody>
                </Card>
            </Col>

            {/* TEKLİF DÜZENLEME MODALI */}
            <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered>
                <ModalHeader toggle={() => setEditModal(false)}>
                    <i className="mdi mdi-pencil text-primary me-2"></i>Teklifi Düzenle
                </ModalHeader>
                <ModalBody>
                    <div className="alert alert-info py-2 px-3 mb-3" style={{fontSize:"13px"}}>
                        Teklif No: <strong>#{editOffer?.ID}</strong> — Mevcut Tutar: <strong>{Number(editOffer?.Price || 0).toFixed(2)} ₺</strong>
                    </div>
                    <FormGroup>
                        <Label className="fw-bold">Yeni Teklif Tutarı (₺)</Label>
                        <Input
                            type="number"
                            min="0"
                            step="0.01"
                            value={editPrice}
                            onChange={e => setEditPrice(e.target.value)}
                            placeholder="Tutar giriniz..."
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={() => setEditModal(false)} disabled={editLoading}>Vazgeç</Button>
                    <Button color="primary" onClick={handleEditSubmit} disabled={editLoading}>
                        {editLoading ? <Spinner size="sm" /> : <><i className="mdi mdi-check me-1"></i>Güncelle</>}
                    </Button>
                </ModalFooter>
            </Modal>

            {/* YENİ: MASRAF DETAYI MODALI */}
            <Modal isOpen={expenseModal} toggle={() => setExpenseModal(false)} centered>
                <ModalHeader toggle={() => setExpenseModal(false)} className="bg-soft-info">
                    <i className="mdi mdi-receipt text-info me-2"></i>Teklifin Masraf Detayları
                </ModalHeader>
                <ModalBody className="p-4">
                    {viewExpense ? (
                        <div>
                            {[
                                { icon: "mdi-gas-station", label: "YAKIT MASRAFI", value: viewExpense.Fuel_Expense },
                                { icon: "mdi-highway", label: "OTOYOL ÜCRETİ", value: viewExpense.Toll_Fee },
                                { icon: "mdi-bus", label: "TOPLU TAŞIMA", value: viewExpense.Public_Transport },
                                { icon: "mdi-taxi", label: "TAKSİ GİDERİ", value: viewExpense.Taxi_Expense },
                                { icon: "mdi-alert-circle-outline", label: "İSTİSNAİ MASRAFLAR", value: viewExpense.Exceptional_Expense },
                            ].map((item, idx) => (
                                <div key={idx} className="d-flex align-items-center justify-content-between py-2 border-bottom">
                                    <div className="d-flex align-items-center">
                                        <div className="me-3 rounded p-2" style={{backgroundColor:"#e1f5fe"}}>
                                            <i className={`mdi ${item.icon} text-info fs-5`}></i>
                                        </div>
                                        <span className="fw-medium text-uppercase" style={{fontSize:"12px"}}>{item.label}</span>
                                    </div>
                                    <span className="fw-bold">{Number(item.value || 0).toFixed(2)} TL</span>
                                </div>
                            ))}
                            <div className="d-flex justify-content-between align-items-center pt-3 mt-2">
                                <span className="fw-bold text-uppercase fs-6">Genel Toplam Masraf</span>
                                <span className="fw-bold text-danger fs-5">{Number(viewExpense.Total_Expense || 0).toFixed(2)} TL</span>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <i className="mdi mdi-alert-circle-outline text-warning" style={{fontSize: "48px"}}></i>
                            <h5 className="mt-2 text-dark">Detay Bulunamadı</h5>
                            <p className="text-muted">Bu teklife ait detaylı masraf kaydı (Advert_Expenses) sistemde bulunmuyor veya `JobDetails` dosyasında tüm masraflar çekilmemiş.</p>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={() => setExpenseModal(false)}>Kapat</Button>
                </ModalFooter>
            </Modal>

            {/* İPTAL ONAY MODALI — iptal ve iade koşullarını kademeli gösterir */}
            <Modal isOpen={cancelModal} toggle={() => !cancelLoading && setCancelModal(false)} centered>
                <ModalHeader toggle={() => !cancelLoading && setCancelModal(false)} className="bg-danger text-white">
                    <i className="mdi mdi-alert-outline me-2"></i> Görevi İptal Et
                </ModalHeader>
                <ModalBody>
                    <p>Görevi iptal etmek istediğinize emin misiniz?</p>
                    <div className="alert alert-warning mb-2">
                        <strong>Görev başlangıcına kalan süre:</strong> {cancelData.diffDays} gün
                    </div>
                    {cancelData.fee > 0 ? (
                        <div className="alert alert-danger mb-2">
                            <i className="mdi mdi-cash-remove me-1"></i>
                            Bu iptal için <strong>{cancelData.fee} TL</strong> ceza uygulanacaktır.
                        </div>
                    ) : (
                        <div className="alert alert-success mb-2">
                            <i className="mdi mdi-check-circle me-1"></i>
                            Ücretsiz iptal hakkınız mevcut.
                        </div>
                    )}
                    <CancelPolicyTable
                        policies={cancelData.policies}
                        diffDays={cancelData.diffDays}
                        activePricingId={cancelData.pricingId}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" outline onClick={() => setCancelModal(false)} disabled={cancelLoading}>Vazgeç</Button>
                    <Button color="danger" onClick={performCancel} disabled={cancelLoading}>
                        {cancelLoading ? <><Spinner size="sm" className="me-1" />İptal ediliyor...</> : "Evet, İptal Et"}
                    </Button>
                </ModalFooter>
            </Modal>

        </React.Fragment>
    );
}

export default DetailsSection;